import {
  SHEET_ACTION_BACK_BUTTON,
  SHEET_ACTION_BACK_DROP,
  SHEET_ACTION_CLOSE_BUTTON,
  SHEET_ACTION_ESCAPE_KEY,
} from "../event/event.activation";
import { sheetClose, sheetGoBack } from "../apis/methods.js";
import { stack } from "../stack/global.svelte";
import { interactionScope } from "./utils";

const log = /*           */ interactionScope.scope("close-handler");
let lastActiveDomElement = $state<HTMLElement | null>(null);

/**
 *
 *
 *
 *
 */
export const onBackdropClick = (): void => {
  sheetClose({ action: SHEET_ACTION_BACK_DROP });
};

/**
 *
 *
 *
 *
 *
 *
 */
export const onCloseButtonClick = (ev: MouseEvent): void => {
  /*                                                           */
  /*                                                                                 */

  /*                                                                  */
  /*                                                             */
  if (ev.detail === 0 && lastActiveDomElement) lastActiveDomElement.focus();

  sheetClose({ action: SHEET_ACTION_CLOSE_BUTTON });
};

export const onBackButtonClick = (): void => {
  sheetGoBack({ action: SHEET_ACTION_BACK_BUTTON });
};

/**
 *
 *
 *
 *
 *
 *
 */
const sheetHandleESCKey = (ev: KeyboardEvent): void => {
  if (ev.code === "Escape") {
    log.info("ESC key pressed, close presentation stack");
    sheetClose({ action: SHEET_ACTION_ESCAPE_KEY });
  }
};

/**
 *
 *
 */
export const useSheetCloseHandler = (): void => {
  $effect.root(() => {
    $effect(() => {
      if (stack.current) {
        log.info(
          "Sheet is open, register ESC key listener, and store last active element",
          document.activeElement,
        );

        /*                                                           */
        lastActiveDomElement = document.activeElement as HTMLElement | null;

        /*                                                                             */
        document.addEventListener("keydown", sheetHandleESCKey);
      } else {
        /*                                                                                      */
        document.removeEventListener("keydown", sheetHandleESCKey);
      }
    });
  });
};
